var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaxtonSoloPricing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 114.596,
    height: 114.646,
    viewBox: "0 0 114.596 114.646",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_40519",
    "data-name": "Path 40519",
    d: "M42.037,49.68H7.643A7.641,7.641,0,0,1,0,42.037V7.643A7.641,7.641,0,0,1,7.643,0H42.037A7.641,7.641,0,0,1,49.68,7.643V42.037a7.641,7.641,0,0,1-7.643,7.643M114.6,42.037V7.643A7.641,7.641,0,0,0,106.953,0H72.559a7.643,7.643,0,0,0-7.643,7.643V42.037a7.643,7.643,0,0,0,7.643,7.643h34.394a7.641,7.641,0,0,0,7.643-7.643m0,64.966V72.609a7.641,7.641,0,0,0-7.643-7.643H72.559a7.643,7.643,0,0,0-7.643,7.643V107a7.643,7.643,0,0,0,7.643,7.643h34.394A7.641,7.641,0,0,0,114.6,107M49.68,107V72.609a7.641,7.641,0,0,0-7.643-7.643H7.643A7.641,7.641,0,0,0,0,72.609V107a7.641,7.641,0,0,0,7.643,7.643H42.037A7.641,7.641,0,0,0,49.68,107",
    fill: "#56aa1c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaxtonSoloPricing);
export default __webpack_public_path__ + "static/media/paxton_solo_pricing.2380e7844c5ab0f2b74341e72046f882.svg";
export { ForwardRef as ReactComponent };